import { render, staticRenderFns } from "./PanicButton.vue?vue&type=template&id=2c5df55c&"
import script from "./PanicButton.vue?vue&type=script&lang=js&"
export * from "./PanicButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports